import { HttpErrorResponse } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

export interface PtrabSessionRepository {
  getSessionStatus(): Observable<HttpErrorResponse | void>;
  ptrabLogin(password: string, sms_hash?: string): Observable<MSafeAny>;
  ptrabLogout(): Observable<MSafeAny>;
}

export const PTRAB_SESSION_REPOSITORY = new InjectionToken<PtrabSessionRepository>('PTRAB_SESSION_REPOSITORY');
